<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import PauseTypeForm from './PauseTypeForm.vue';

const { t } = useI18n();
const store = useStore();
const router = useRouter();

const uiFlags = useMapGetter('agentPauseTypes/getUIFlags');
const currentAccountId = useMapGetter('getCurrentAccountId');

const goToList = () => {
  router.push({
    name: 'agent_pause_types_list',
    params: { accountId: currentAccountId.value },
  });
};

const onSubmit = async payload => {
  try {
    await store.dispatch('agentPauseTypes/create', payload);
    useAlert(t('AGENT_PAUSE_TYPES.API.CREATE_SUCCESS'));
    goToList();
  } catch (error) {
    useAlert(error?.message || t('AGENT_PAUSE_TYPES.API.ERROR'));
  }
};
</script>

<template>
  <SettingsLayout>
    <template #header>
      <BaseSettingsHeader
        :title="t('AGENT_PAUSE_TYPES.NEW_PAUSE_TYPE')"
        :description="t('AGENT_PAUSE_TYPES.DESCRIPTION')"
      />
    </template>
    <template #body>
      <div class="max-w-3xl">
        <PauseTypeForm
          :submit-label="t('AGENT_PAUSE_TYPES.FORM.SUBMIT')"
          :is-submitting="uiFlags.isCreating"
          @submit="onSubmit"
          @cancel="goToList"
        />
      </div>
    </template>
  </SettingsLayout>
</template>
